import React from "react"

// data
import soz_studio from "../../assets/images/microphone.png"

const About = () => {
  return (
    <section id="about" className="about">
      <div className="row">
        <div className="column-left">
          <div className="column-container">
            <h2>About Us</h2>
            <div className="descr">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Scelerisque auctor pulvinar urna eget. Libero porttitor lectus
                orci odio.
              </p>
              <br />
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Scelerisque auctor pulvinar urna eget. Libero porttitor lectus
                orci odio. Lorem ipsum dolor sit amet, consectetur adipiscing
                elit.
              </p>
              <br />
              <p>
                Scelerisque auctor pulvinar urna eget. Libero porttitor lectus
                orci odio.
              </p>
            </div>
          </div>
        </div>
        <div className="column-right">
          <div className="img-container">
            <img src={soz_studio} alt="soz studio" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
